// extracted by mini-css-extract-plugin
module.exports = {"container":"not-found_container__3DdBK","textContainer":"not-found_textContainer__3zX5Y","redirectContainer":"not-found_redirectContainer__wsv57"};